// extracted by css-extract-rspack-plugin
export default {"body":"eKOZFboJ8Hw8CmSG","form":"sYxQ30z1GUsF46JK","helpText":"gYMySJimS0AMLLRG","selectedContentPreview":"fEp6ywB10ITBHVEW","selectedContentText":"YkISj4ZQA1vJKcNr"};